"use client"
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import CelebrationIcon from '@mui/icons-material/Celebration';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import AirlinesIcon from '@mui/icons-material/Airlines';
import GroupIcon from '@mui/icons-material/Group';
import TtkList from './TtkList';

const MehandiTTK = ({ data }) => {
    return (
        <>
            <div className='row'>
                <div className='col-md-12'>
                    <div className='row mb-1'>
                        <div className='col-md-3'>
                            <p><WorkspacePremiumIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Working Since :</b>&nbsp;<TtkList data={data?.workingSince} /></p>
                        </div>
                        <div className='col-md-3'>
                            <p><MonetizationOnIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Bridal Mehandi Price :</b>&nbsp;<span>&#8377;{data?.mehandiPrice}</span></p>
                        </div>
                        <div className='col-md-3'>
                            <p><GroupIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Maximum Guest :</b>&nbsp;<span>{data?.maxGuest}</span></p>
                        </div>
                        <div className='col-md-3'>
                            <p><GroupIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Number Of Employees :</b>&nbsp;<span>{data?.noOfEmployee} </span></p>
                        </div>
                    </div>
                    <div className='row mb-1'>
                        <div className='col-md-3'>
                            <p><LocationOnIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Area of working :</b>&nbsp;<TtkList data={data?.areaOfWork} /></p>
                        </div>
                        <div className='col-md-3'>
                            <p><MonetizationOnIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Travel Cost :</b>&nbsp;<TtkList data={data?.travelCost} /></p>
                        </div>
                        <div className='col-md-3'>
                            <p><MonetizationOnIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Coust/Family Per Hand Price :</b>&nbsp;<span>&#8377;{data?.mehandiPerHandPrice}</span></p>
                        </div>
                        <div className='col-md-3'>
                            <p><MonetizationOnIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Traditional Mehandi Price :</b>&nbsp;<span>&#8377;{data?.TranditionalMehandi}</span></p>
                        </div>

                    </div>

                    <div className='row mb-1'>
                        <div className='col-md-3'>
                            <p><AirlinesIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Travel Preference :</b>&nbsp;<TtkList data={data?.TravelPreference} /></p>
                        </div>
                        <div className='col-md-3'>
                            <p><CelebrationIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Mehandi Design Type :</b>&nbsp;<TtkList data={data?.mehandiDesign} /></p>
                        </div>
                    </div>
                 </div>
            </div>
         </>
    )
}

export default MehandiTTK